<app-modal
  *ngIf="mainContent && secondaryAction && primaryAction"
  [modalTitle]="'general.investmentQualification'"
  [mainContentTemplate]="mainContent"
  [secondaryActionTemplate]="secondaryAction"
  [primaryActionTemplate]="primaryAction"
  (closed)="activeModal.dismiss()"
></app-modal>

<ng-template #mainContent>
  <label class="mb-2"
    >{{
      "registrationWizard.investorRatingModal.investorRatingClarify" | translate
    }}
  </label>
  <label class="mb-0"
    >{{
      "registrationWizard.investorRatingModal.investorRatingClarifyInfo"
        | translate
    }}
  </label>

  <div class="row flex-between-center">
    <app-validated-checkbox
      [inputFormControl]="understood"
      inputFormControlName="understandClarification"
      label="general.understood"
      [validationTrainslations]="{
        required: 'registrationWizard.concentIsRequired'
      }"
    ></app-validated-checkbox>
  </div>
</ng-template>

<ng-template #secondaryAction>
  <button
    class="btn btn-falcon-default btn-sm me-3"
    type="button"
    (click)="handleSecondaryAction()"
  >
    {{ "general.cancel" | translate }}
  </button>
</ng-template>

<ng-template #primaryAction>
  <button
    class="btn btn-primary btn-sm"
    type="submit"
    (click)="handlePrimaryAction()"
  >
    {{ "general.next" | translate
    }}<span class="fas fa-chevron-right ms-2" data-fa-transform="shrink-3">
    </span>
  </button>
</ng-template>
